// these redux actions are specific to send a form even though they
// modify the state of the form editor
// -----------------------------------------------------------------------------

import { GetStateFunction } from 'gf-types';
import { initFormEditor } from '../formeditor/actions';
import { ViewType } from './contants';
import {
  SEND_A_FORM_PREVIEW_FORM_VIEW,
  SEND_A_FORM_INIT,
  SEND_A_FORM_PREVIEW_LIST_VIEW,
  SEND_A_FORM_CLOSE,
  SEND_A_FORM_FIELD_CLICKED,
  SEND_A_FORM_FIELD_CLICKED_HANDLED,
  SEND_A_FORM_SET_SELECTED_FIELDS
} from './reduxActionTypes';
import { FormEditorDispatch, FormEditorView } from '../formeditor/formeditor-types';

export const highlightSelectedPreviewFields = (fieldIds: string[], color: string, viewType: ViewType) => (dispatch: FormEditorDispatch) => {
  const type = viewType === ViewType.FormView ? SEND_A_FORM_PREVIEW_FORM_VIEW : SEND_A_FORM_PREVIEW_LIST_VIEW;

  dispatch({ type, payload: { fieldIds, highlightColor: color } });
};

export const initPreviewForm =
  (formOrTemplateId?: string, isTemplate = false) =>
  async (dispatch: FormEditorDispatch, getState: GetStateFunction) => {
    if (!isTemplate) {
      // init the form normally, then set a value saying that it's from send a form
      await initFormEditor(null, formOrTemplateId, null)(dispatch, getState);
      return;
    }

    // a template was selected so we need to load a preview form
    // since we're loading from the send a form modal, we need to send in a preset query param object
    await initFormEditor(null, null, null, null, { preview: 'true', templateid: formOrTemplateId })(dispatch, getState);
  };

export const initSendAForm = () => (dispatch: FormEditorDispatch) => {
  dispatch({ type: SEND_A_FORM_INIT, payload: { sendAForm: { interactive: false, selectedFieldPositionIds: [] } } });
};

/**
 * Closes the underlying form editor and send a form state.
 *
 * @param completely Completely close the form editor state and send a form state.
 */
export const closeSendAForm =
  (completely = true) =>
  (dispatch: FormEditorDispatch) =>
    dispatch({ type: SEND_A_FORM_CLOSE, payload: { completely, interaceive: true } });

export const sendAFormPreviewFieldClicked = (fieldId: string, viewType: FormEditorView) => (dispatch: FormEditorDispatch) => {
  dispatch({ type: SEND_A_FORM_FIELD_CLICKED, payload: { fieldId, viewType } });
};

export const sendAFormPreviewFieldClickedHandled = () => (dispatch: FormEditorDispatch) => {
  dispatch({ type: SEND_A_FORM_FIELD_CLICKED_HANDLED });
};

export const setSelectedFields = (selectedFieldIds: string[]) => (dispatch: FormEditorDispatch) => {
  dispatch({ type: SEND_A_FORM_SET_SELECTED_FIELDS, payload: { selectedFieldIds } });
};
